module.exports = __webpack_public_path__ + "img/jianianhua_img1.204786eb.jpg";